export default __webpack_public_path__ + "static/why_choose_ecomm-7328a34a45d98d7d30b153db55d2ced7.webp";